export const translationLivechat_en_case = {
  livechatCaseCreate: "Create case",
  livechatCaseDialogTitle: "Create case",
  livechatCaseDialogDescription:
    "Sends this chat by email, the same way the chosen contact form sends a request.",
  livechatCaseTopic: "Topic",
  livechatCaseTopicPlaceholder: "Choose a topic",
  livechatCaseNote: "Note for the case (optional)",
  livechatCaseNotePlaceholder: "What should happen with this case?",
  livechatCaseIncludesTranscript: "The chat transcript is included in the case.",
  livechatCaseSubmit: "Create case",
  livechatCaseSubmitting: "Creating case...",
  livechatCaseCancel: "Cancel",
  livechatCaseCreated: "Case created",
  livechatCaseCreatedDescription: "Sent to {recipient}",
  livechatCaseFailed: "The case could not be created. Try again.",
};
